import ImagesCountriesDESvg from '@/public/images/countries/DE.svg';
import ImagesCountriesENSvg from '@/public/images/countries/EN.svg';
import ImagesCountriesESSvg from '@/public/images/countries/ES.svg';
import ImagesCountriesFRSvg from '@/public/images/countries/FR.svg';
import ImagesCountriesITSvg from '@/public/images/countries/IT.svg';

export {
  ImagesCountriesDESvg,
  ImagesCountriesENSvg,
  ImagesCountriesESSvg,
  ImagesCountriesFRSvg,
  ImagesCountriesITSvg,
};
